import { makeStyles } from "tss-react/mui";

interface IParams {
    isSelected?: boolean;
    isFlagged?: boolean;
}

const getDefaultCardStyle = (isFlagged: boolean | undefined, warningColor: string, primaryColor: string) =>
    isFlagged ? warningColor : primaryColor;

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    selectableRowContainer: {
        marginBottom: theme.spacing(1),
    },
    rowContentContainer: {
        position: "relative",
        alignItems: "center",
        border: `2px solid ${
            props?.isSelected
                ? getDefaultCardStyle(props?.isFlagged, theme.palette.warning.main, theme.palette.primary.main)
                : theme.palette.secondary.main
        }`,
        borderRadius: 8,
        cursor: "pointer",
        "& .MuiGrid-root.MuiGrid-item>svg": {
            display: "block",
            margin: "auto",
            color: theme.palette.primary.light,
            minWidth: 45,
            minHeight: 45,
        },
        "&:hover": {
            borderColor: `${props?.isFlagged ? theme.palette.warning.main : theme.palette.primary.main}`,
        },
        flexGrow: 1,
    },
    selectedRowCheckContainer: {
        position: "absolute",
        right: -1,
        top: -1,
        width: "2.5rem",
        height: "2.5rem",
        background: theme.palette.primary.main,
        clipPath: "polygon(0 0, 100% 0, 100% 100%)",
        borderTopRightRadius: 8,
    },
    selectedRowCheck: {
        color: theme.palette.common.white,
        position: "absolute",
        right: 2,
        top: 2,
    },
    firstRow: {
        "& > figure > div": {
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
        },
    },
    notFirstRow: {
        "& > figure > div": {
            marginTop: -8,
            paddingTop: 8,
            height: "calc(100% + 8px)",
        },
    },
    lastRow: {
        "& figure > div": {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
        },
    },
}));
